import { GAME_SFX_CLICK_SELECT } from 'app/constants/GameSFX';

class ButtonFixedPosition extends Phaser.Button {
  constructor({ game, id, x, y, sfxID, skin, ariaLabelID }) {
    super(game, x, y, 'buttons');
    this.setFrames(skin, skin, skin, skin);
    this.id = id;
    this.input.useHandCursor = true;
    this.game.time.events.add(1, this.init, this);
    this.anchor.set(0.5);
    this.enable();
  }

  init() {
    this.enable();
  }

  enable() {
    this.onInputDown.add(this.onDown, this);
  }

  disable() {
    this.onInputDown.forget();
    this.onInputDown.dispose();
    this.onInputDown.removeAll();
  }

  onDown() {
    this.game.sounds.playSFX(GAME_SFX_CLICK_SELECT);
  }

  destroy(destroyChildren = true) {
    this.disable();
    super.destroy(destroyChildren);
  }
}
export default ButtonFixedPosition;
